// extracted by mini-css-extract-plugin
export default {"author":"author_author__Fczag","authorName":"author_authorName__lTp0-","avatar":"author_avatar__ezTy-"};